import React from "react";
import styles from "../../pages/Community/CreateCommunityPage.module.css";
import placeholderImage from "../../assets/images/image-upload-placeholder.png";

const GroupsList = ({
  videoTabs,
  activeTabIndex,
  activeGroupIndex,
  setActiveGroupIndex,
  currentGroup,
  setCurrentGroup,
  editGroupIndex,
  isSubmitting,
  handleGroupBannerWebUpload,
  handleGroupBannerMobileUpload,
  handleAddOrUpdateGroup,
  handleEditGroup,
  handleDeleteGroup,
  handleMoveGroupUp,
  handleMoveGroupDown,
}) => {
  const currentTabData = videoTabs[activeTabIndex];
  const currentGroups = currentTabData?.groups || [];

  if (videoTabs.length === 0) return null;

  return (
    <div className={styles.sectionsCard}>
      <h4 className={styles.subSectionTitle}>
        Groups in "{currentTabData?.tab_name || "Selected Tab"}"
      </h4>

      {/* Group Banner (Website) Upload */}
      <div className={styles.imageSectionWrapper}>
        <label className={styles.inlineLabel}>Group Banner (Website)</label>
        <div className={styles.featuredImageBox}>
          {(currentGroup.group_banner_web_url || currentGroup.group_banner_web_file) ? (
            <>
              <img
                src={currentGroup.group_banner_web_url ?? URL.createObjectURL(currentGroup.group_banner_web_file)}
                alt="Group Banner (Website)"
                className={styles.featuredImageBox}
              />
              <button
                type="button"
                onClick={() =>
                  setCurrentGroup({
                    ...currentGroup,
                    group_banner_web_url: null,
                    group_banner_web_file: null,
                  })
                }
                className={styles.removeImageButton}
                disabled={isSubmitting}
                title="Remove image"
              >
                ✕
              </button>
            </>
          ) : (
            <div className={styles.iconPlaceholderContainer}>
              <img
                src={placeholderImage}
                alt="Placeholder"
                className={styles.iconPlaceholder}
              />
              <div className={styles.uploadLinks}>
                <label className={styles.uploadLink}>
                  <span className={styles.plusIcon}>+</span> Choose Group Banner (Website)
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleGroupBannerWebUpload}
                    disabled={isSubmitting}
                  />
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Group Banner (Mobile) Upload */}
      <div className={styles.imageSectionWrapper}>
        <label className={styles.inlineLabel}>Group Banner (Mobile)</label>
        <div className={styles.featuredImageBox}>
          {(currentGroup.group_banner_mobile_url || currentGroup.group_banner_mobile_file) ? (
            <>
              <img
                src={currentGroup.group_banner_mobile_url ?? URL.createObjectURL(currentGroup.group_banner_mobile_file)}
                alt="Group Banner (Mobile)"
                className={styles.featuredImageBox}
              />
              <button
                type="button"
                onClick={() =>
                  setCurrentGroup({
                    ...currentGroup,
                    group_banner_mobile_url: null,
                    group_banner_mobile_file: null,
                  })
                }
                className={styles.removeImageButton}
                disabled={isSubmitting}
                title="Remove image"
              >
                ✕
              </button>
            </>
          ) : (
            <div className={styles.iconPlaceholderContainer}>
              <img
                src={placeholderImage}
                alt="Placeholder"
                className={styles.iconPlaceholder}
              />
              <div className={styles.uploadLinks}>
                <label className={styles.uploadLink}>
                  <span className={styles.plusIcon}>+</span> Choose Group Banner (Mobile)
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleGroupBannerMobileUpload}
                    disabled={isSubmitting}
                  />
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      <input
        type="text"
        placeholder="Group title"
        value={currentGroup.group_title}
        onChange={(e) =>
          setCurrentGroup({
            ...currentGroup,
            group_title: e.target.value,
          })
        }
        className={styles.textInput}
        disabled={isSubmitting}
      />

      <textarea
        placeholder="Group description (optional)"
        value={currentGroup.group_description}
        onChange={(e) =>
          setCurrentGroup({
            ...currentGroup,
            group_description: e.target.value,
          })
        }
        className={styles.textAreaLarge}
        rows="3"
        disabled={isSubmitting}
      />

      <button
        className={styles.submitButton}
        onClick={handleAddOrUpdateGroup}
        disabled={isSubmitting}
      >
        <span>{editGroupIndex === -1 ? "Add Group" : "Update Group"}</span>
        <span className={styles.submitIcon}>
          {editGroupIndex === -1 ? "+" : "✓"}
        </span>
      </button>

      {/* Groups List */}
      <div className={styles.sectionList}>
        {currentGroups.map((group, index) => (
          <div
            key={index}
            className={`${styles.sectionRow} ${activeGroupIndex === index ? styles.activeRow : ""
              }`}
            onClick={() => setActiveGroupIndex(index)}
          >
            <div className={styles.reorderButtons}>
              <button
                className={styles.arrowButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMoveGroupUp(index);
                }}
                disabled={index === 0 || isSubmitting}
                title="Move up"
              >
                ▲
              </button>
              <button
                className={styles.arrowButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMoveGroupDown(index);
                }}
                disabled={index === currentGroups.length - 1 || isSubmitting}
                title="Move down"
              >
                ▼
              </button>
            </div>

            <span className={styles.sectionLabel}>{group.group_title}</span>

            <div className={styles.sectionActions}>
              <button
                className={styles.editIconButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditGroup(index);
                }}
                disabled={isSubmitting}
              >
                ✎
              </button>
              <button
                className={styles.deleteIconButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteGroup(index);
                }}
                disabled={isSubmitting}
              >
                🗑
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GroupsList;
